// [PURPOSE]: Build the shadow Quick-Bonus entry ClassResourcesPanel writes when a
//   Barbarian Rage use is consumed, so effectCalculator._buildContext can detect
//   raging via findQuickBonusOfKind(activeQuickBonuses, 'rage').
// [WHY]: Rage damage bonus scales by Barbarian level (PHB p.48: +2 at L1, +3 at L9,
//   +4 at L16). Pre-fix the shadow entry hardcoded a flat value:2 (NS-QB-rage-scaling
//   breadcrumb). The bonus is now resolved through the registry-driven
//   `rage_damage_bonus` formula (effectCalculator.calculateRageDamage →
//   effectRegistry._getValue → resolveByLevelTable on
//   SRD_CLASS_FEATURES.Barbarian.Rage.rageDamageByLevel), NOT a hardcoded ladder
//   (Rule 11: data-driven; strings/ladders go against god).
// [INTEGRATION]: Single source of truth for the shadow entry shape — imported by
//   ClassResourcesPanel.updateResource (producer) AND the sub-plan-4G raging-context
//   test (Rule 22: test drives the real production builder, not an inline replica).
import { effectCalculator } from '../services/effectCalculator';

/**
 * Build the level-scaled shadow Rage Quick-Bonus entry.
 * @param {Object} character - playerStats (reads classes[] for Barbarian level)
 * @returns {Object} shadow QB entry { type, id, name, icon, bonus, affects, duration, value, _shadow }
 */
export function buildRageShadowEntry(character) {
  // calculateRageDamage returns the level-correct bonus (0 for non-Barbarians).
  // The shadow entry is only written on a Rage consume, so the character is always
  // a Barbarian; fall back to the L1 value (2) defensively if the resolver returns 0.
  const bonus = effectCalculator.calculateRageDamage(character) || 2;
  return {
    type: 'rage',
    id: 'rage',
    name: 'Rage',
    icon: '💢',
    bonus: `+${bonus}`,
    affects: 'Damage (STR melee)',
    duration: '1 min',
    value: bonus,
    _shadow: true, // internal marker — this entry is ClassResourcesPanel-managed
  };
}
